import { api } from '../api'
import { useCachedFetch } from '../lib/swr'

// Marches publics — charges UNE SEULE FOIS au niveau App puis partages avec
// l'intro et l'accueil (evite le double-fetch de /public/marches a l'entree du hub).
// Cache SWR persistant : au warm start, le dernier etat connu s'affiche
// INSTANTANEMENT (pas de skeleton), puis revalidation en silence.
// Contrat de retour inchange : null = jamais charge, [] = erreur sans cache.
export default function useMarchesPublics() {
  const { data, loading } = useCachedFetch(
    '/public/marches',
    async () => {
      const d = await api.getMarches()
      return Array.isArray(d) ? d : []
    },
    { persist: true },
  )
  if (data !== undefined) return data
  return loading ? null : []
}
